/**
 * ThemeToggle — interrupteur Mode Nuit (DESIGN.md §3).
 *
 * Bascule `data-theme="night"` sur <html> et persiste dans localStorage
 * (`ge-theme`) ; le script inline d'index.html ré-applique le choix avant le
 * premier rendu (pas de flash). Aucune logique métier — pur préférence d'UI.
 *
 * Exposé à TOUS depuis la conversion des pages en tokens (v4.56) : sans
 * choix enregistré, le script inline d'index.html suit le réglage sombre du
 * téléphone ; un tap ici enregistre un choix EXPLICITE ('night' / 'clair')
 * qui prime ensuite sur le système.
 */

import { useState } from 'react';
import GeIcon from './GeIcon.jsx';
import './ThemeToggle.css';

const STORAGE_KEY = 'ge-theme';

function ThemeToggle() {
  const [night, setNight] = useState(
    () => document.documentElement.getAttribute('data-theme') === 'night'
  );

  const toggle = () => {
    const next = !night;
    setNight(next);
    if (next) {
      document.documentElement.setAttribute('data-theme', 'night');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
    document.querySelector('meta[name="theme-color"]')
      ?.setAttribute('content', next ? '#0B1F15' : '#15803d');
    try {
      // Choix explicite mémorisé dans les deux sens — 'clair' empêche
      // l'auto-détection sombre de re-basculer au prochain lancement.
      localStorage.setItem(STORAGE_KEY, next ? 'night' : 'clair');
    } catch { /* stockage indisponible : le choix vaut pour la session */ }
  };

  return (
    <button
      type="button"
      className="theme-toggle"
      onClick={toggle}
      aria-pressed={night}
      title={night ? 'Passer en mode clair' : 'Passer en mode nuit'}
    >
      <GeIcon name={night ? 'soleil' : 'lune'} />
      <span className="sr-only">{night ? 'Mode clair' : 'Mode nuit'}</span>
    </button>
  );
}

export default ThemeToggle;
